import { render } from "./ReservationExam.vue?vue&type=template&id=4ce62014"
import script from "./ReservationExam.vue?vue&type=script&lang=js"
export * from "./ReservationExam.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__